export default __webpack_public_path__ + "static/media/pexels-matthias-cooper.654b6488.jpg";